import React from 'react';
import PropTypes from 'prop-types';

import { useEvieAppContext } from 'components/evieApp/EvieAppProvider';

const UserName = ({ displayName }) => {
  const { personalInfo: { name = '' } = {} } = useEvieAppContext();

  return (
    <section className="evie-profile__username">
      <div className="evie-profile__username_initial">
        <span>{name && name[0] ? name[0].toUpperCase() : ''}</span>
      </div>
      {displayName ? <h3 className="evie-profile__username_label">{name}</h3> : null}
    </section>
  );
};

UserName.defaultProps = {
  displayName: true,
};

UserName.propTypes = {
  displayName: PropTypes.bool,
};

export default UserName;
